export default {
  message: {
    homePage: 'トップページ',
		productIntroduction:'商品の紹介',
    commodity:' 製品',
		commodityHeader:' 製　　品',
    companyOverview:'会社概要',
    ceramicware:'セラミック',
    shangpings:'ひょうたんびん',
    shangpingh:'コップ',
    shangpingz:'しょくぶつ',
    productIntroductionp:'製品紹介',
    companyOverviewc:'会社紹介',
		huaping:'ひょうたんびん',
    huaping:'かびん',
    xianrenzhang:'サボテン',
    taochiwan:'セラミックボ',
    taochiquan:'クリング',
    taochibei1:'クカップ',
    taochihu:'クポット',
    zhiwubei:'つカップ',
    zhiwuwan:'くぶつ',
    chahu:'きゅうす',
    lvchahu:'グリーン',
    Product:'製品',
    Introduction:'紹介',
    company:'会社',
    Overview:'概要',
    Companyname:'社  名',
    Establishmentdate:'設立日',
    Sukihon:'資本金',
    millionyen:'1000万円',
    Atable:'代表者',
    Representative:'代表取締役 包海',
    Businesscontents:'事業内容',
    Contents1:'植木、植物苗、陶器、生活雑貨品の輸出輸入業務',
    Contents2:'絵画、古物、骨董品、美術工芸品の販売及び輸出輸入業務',
    Contents3:'古物営業法に基づく古物商',
    Contents4:'輸出輸入業務の代行業',
    Mainbusinesses:'主な業務は次のとおりです',
    consult:'いつでもお問い合わせください',
		benshe:'本社倉庫',
		dier:'第二倉庫',
    home:'陶磁器素材の溶き皿・梅皿・筆洗などの画材用品を販売しており、特に日本画に関するお客様に幅広くご利用いただいています。OEMでのオリジナル画材用品制作の実績もございます。',
    page:'株式会社サンシャイン（岐阜県多治見笠原町上原1254-1）最新の組織培養施設で生産しているため、高品質な組織培養苗を短納期・低価格でご提供することが可能です。お気軽にご相談ください。',
		tosring:'株式会社サンシャイン（岐阜県多治見笠原町上原1254-1主に花木、中古、陶器、生活雑貨の輸出輸入を含む業務を担当しておりますのでお気軽にお問い合わせください。',
    pasring:'酒器です。開口、浅腹、臥足。杯の上に雌、雄鶏及び雛鶏を闘彩で描き、間に山石、蘭草、牡丹を用いたので、鶏かめ杯と呼ばれている。',
    orsring:'平安樹平安樹の本名は蘭嶼シナモン、クスノキ科、クスノキ属常緑小高木で、家庭でよく見られる観賞性木本植物である。',
    iasring:'葉はエメラルドグリーンに密集し、クリスマスの祝日に近づくと花が咲き、群れをなし、花色が豊富で、人に愛される室内盆栽の花である。',
    uasring:'高さは15 ~ 25メートル、胸の径は50センチに達し、冠幅は広く広がっている。老木にはさび褐色の気根がよくある。樹皮が濃い灰色。',
    yasring:'桑科、ガジュマル族、ガジュマル属の大高木植物で、幼い頃に他の木に付着し、葉革質、三角状卵形、基生葉脈三出、葉柄が細く、ガジュマルの球形から扁平球形まで',
    lasring:'手押し杯',
    kasring:'鶏つぼカップ',
    dity:'自社の組織培養苗をポット苗、または完成品にして生産も可能です。 基本はコンテナ利用となりますが、生産者様のご希望にも対応をさせていただいていますので、お気軽にご相談下さい。',
    taochi:'日本人スタッフにより全ての工程が管理され、日本品質の陶器の製造が可能です非常に良い立地条件のため、日本へのスムーズな出荷が可能です。',
    home1:'本社は陶磁器生産量日本一の岐阜県美濃地方に位置し、多数のメーカーのご協力によりあらゆる陶磁器製品の取り扱いが可能です。',
		jasring:'迎客松',
		hasring:'合歓樹',
		gasring:'ローハンソン',
		fasring1:'ホトトギス',
		xasring:'松の木',
		zasring:'美人松',
		casring:'黒松',
		qasring:'きんぴら松',
		aasring:'馬尾松',
		fasring:'ヒマラヤスギ本',
		qq:'大板松',
		ww:'あぶら松',
		ee:'インドマツ',
		rr:'五針松',
		tt:'カラマツ',
		yy:'文人の木',
		uu:'クロックカップ',
		ii:'クロックカップ',
		oo:'手押し杯',
		pp:'ようゆうカップ',
		aa:'たけいとカップ',
		ss:'イヤーカップ',
		dd:'鶏つぼカップ',
		ff:'こうそく杯',
		gg:'羅漢カップ',
		hh:'鈴の杯',
		jj:'ぼうねつカップ',
		kk:'馬蹄杯',
		ll:'グラス',
		zz:'高足の茶碗',
		xx:'カップ1杯',
		cc:'カップ1杯',
		vv:'サイドハンドルポット',
		bb:'公平な茶碗',
		nn:'急須ティーポット',
		mm:'ハスの葉の磁器ボウル',
		mn:'美濃焼急須',
		nb:'笠カップ',
		bl:'羅漢杯',
		dl:'手描きセラミックボウル',
		dm:'ビーム',  
		dn:'花口皿',
		db:'白泥カップ',
		dc:'茶碗に寝かす',
		qw:'客を迎える松如人は片腕を伸ばして遠くから来た客を歓迎し、もう一方の手は優雅にズボンのポケットに斜めに差し込んで、おっとりしていて、姿が優美だ。',
		qe:'喜光、乾燥に耐えてやせている。木材は赤褐色で、木目はまっすぐで、構造は細く、乾燥時に割れやすく、家具、枕木などを作ることができる。',
		qr:'羅漢松は常緑針葉高木に属し、高さ20 m、胸径60 cmに達する。樹皮は灰色または灰褐色で、浅く縦に裂け、薄いシート状に脱落している。枝は展開したり斜めに展開したりして、比較的に密です。',
		qt:'双子葉植物綱、ツツジ科、ツツジ属の常緑低木、落葉低木。',
		qy:'マツ科植物の1属、常緑高木、稀低木、樹脂がある、樹皮は滑らかになったり、縦に裂けたり、片状にはがれたりします。',
		qu:'常緑高木、高さ25-32メートル、胸径25-100センチ、下部樹皮は淡黄褐色から暗灰褐色にかけて、不規則な鱗片に裂けた。',
		qi:'別名白芽松、常緑高木、高さ30メートル、樹皮は灰色黒色を帯び、多くの花粉が風に漂う。',
		qo:'葉は棒状で、扁平で柔らかく、長い枝の上に螺旋状に散生し、短い枝の上に15 ~ 30枚の群生し、周囲に放射して平らに広がり、秋後に黄金色になり、銅銭のように丸くなったので、この名がついた。',
		qp:'尾松は腐食に弱い。心辺材の区別は明らかではなく、淡黄褐色、長縦割れ、長片状のはがれ、木目がまっすぐで、構造が太い、樹脂を含み、耐水性がある。',
		qa:'常緑高木、樹冠尖塔形、大枝は平らで、小枝は少し垂れ下がっている。葉針形、長さ8－60センチ、質が硬く、灰色緑色または銀灰色で、長枝に散生し、短枝に群生する。',
		qs:'大板松は常緑針葉樹種であり、日本の五針松の栽培変種の一つであり、葉五針一束、葉の色は黄色に偏っており、株は低く、姿は古風で蒼然としている。',
		qd:'松科針葉常緑高木で、高さ25メートル、胸径1メートルに達することができる。樹皮の下部は灰褐色で、不規則な鱗に割れている。',
		qf:'心材は淡黄赤褐色、辺材は淡黄白色、テクスチャはまっすぐで、構造は比較的細かく、材質は比較的に硬く、耐久用である。',
		qg:'日本の五針松は針葉が美しく、また長期接ぎ木による高成長が抑制されて茂み状になった小高木で、枝が優美で、貴重な観賞樹種である。',
		qh:'冬芽はほぼ円球形で、芽鱗は暗褐色で、縁にまつげがあり、基部芽鱗の先端に長い尖頭がある。',
		qj:'明らかな幹があり、枝が細長く、斜めに伸び、塔形または傘形の樹冠がある。冬芽は赤褐色、卵形、樹脂なし。',
		wq:'逆ボタンは鐘の形のようで、杯の身長は選び、器型は俊逸で、つまみ、香りを嗅ぎやすい。ロック香、香り、飲み物の多機能を一体化し、ここ数年来比較的に流行しているスタイルである。',
		we:'押さえカップはカップの一種の様式である。押さえカップの造形は口が平坦で外すくいで、腹壁は垂直に近く、下腹壁から内収め、足を囲む。',
		wr:'笠杯の造形は蓑翁の笠のようで、杯の口は大きくて、杯の体は大きくて、杯の足は小さくて、その悠然自得の美の線を取って簡潔で優雅で、焼成の難度は高くて、簡潔の中で大智を見て、特に貴重である。',
		wt:'外形は丸みを帯びた腹はやや内包しており、その集香と集味の効果もより顕著で、最も茶葉の食感を引き出すことができる器型と言える。',
		wy:'腹はやや外側に膨らみ、口径はやや内側に収まりますが、比較的に真実で正常ですが、その集香と集味の効果は明らかにもっと良く、総合食感は最も良いです。',
		wu:'器具の外形は楕円、浅腹、平底で、両側に半月形の両耳があり、時には餅形の足や高足もある。',
		wi:'杯体は闘彩で線鶏が早哺雛をつつく姿を描き、牡丹、蘭、柱石紋を添えて生き生きとしていることから、その名がついた。',
		wo:'それは高足の茶碗と同じで、上は茶碗形で、下には高柄がある。カップとも呼ばれ、外観が美しく、実用的で便利です。',
		wp:'形が特別だ。カップの口は内に収まり、持ち上げる時は普通のカップが外の贅沢なカップの口につまむことができるのではなく、膨らんだ腹部にしか握ることができない。',
		wa:'杯の口の外にすくい、深い腹、輪足、逆さまに鈴のように置くことから名付けられた。',
		ws:'開口部、浅斜式腹壁、輪足、杯体は秋菊、蝶、草で画面を構成しているので、三秋杯と呼ばれている。',
		wd:'馬蹄杯口部と器身差はあまり幅がなく、口部は器身よりやや広く、器身は比較的方正で、弧線は小さい。',
		wf:'酒を飲む道具。直線の口は辺に沿って微すくい、口の下は徐々に収束し、浅い丸足の造形は小さくふっくらしている。',
		wg:'造形はハイキックカップに似ており、やや大きい。全体の造形の上で比較的に独特です。',
		wh:'形式は非常に豊富で、その中の茶碗口には多種の芸術形式があり、しかも茶碗体は深い腹と膨れ腹の2種類に分けられる。',
		wj:'大きなカップに対して、カップの1つのタイプで、通常口径は8センチ以内です。小さなカップは形が小さくて精巧で、制作の多くは比較的精巧で美しい。',
		aq:'側把壺、茶器、壺身は背状を呈し、壺把持は横柄（横柄壺とも呼ばれる）であり、壺身、壺流とともに90度角を呈し、壺把持が長いため',
		aw:'公道茶碗は酒を飲む容器であり、今ではお茶を飲む上で欠かせない茶器となっている。',
		ae:'急須とは通常、サイドハンドル（日本語で「横手」という）付きの急須のことを指す。サイドハンドルの形をしたポットは日本独自のものです。',
		ar:'ハスの花をモチーフにした紋様、開閉相間、色があでやかで変化に富んでいる、姿勢の変化が多く、全体的にコンパクトでエレガントな表現',
		at:'美濃焼美濃焼は日本の有名な磁器で、特色が鮮明で、様式が精緻である。日常生活だけでなく、コレクション価値もある',
		ay:'蓑翁の笠のような形をしており、口は大きく、底は小さく、その悠然とした美しさを取り、線は簡潔で優雅である',
		au:'カップの口の中に収まり、腹部が丸く膨らんだ弥勒仏のような腹は、普通のカップが外の贅沢なカップの口につまむのではなく、膨らんだ腹部にしか握れない。',
		ai:'成形乾燥した食器素子の胎に色材を用いて図案を描き、その後透明釉やその他の薄い色の面釉で覆い、。',
		ao:'提梁壺提梁壺小口球腹、下承三獣足、肩側に竜頭流があり、肩部二部が半月形提梁でつながっている',
		ap:'花口板の縁、腹を膨らませ、凸稜は菊弁のように、足を囲む。胎体は重厚で大きく、全身に細かい紋様片をつけている。',
		as:'泥の色度は白く、粘性はよりよく、焼成後の磁器は青くならず白く見える。高白泥で焼かれた白磁カップは外観から見ると、色がより白くつやつやしている。',
		ad:'臥足碗臥足碗は茶碗の一種の様式である。浅腹、茶碗底心内凹、茶碗壁を丸足として用いたので、臥足茶碗と呼ばれる。',
		
  }
}